module.exports = __webpack_public_path__ + "img/t1-salmon.f2979981.png";